import axios from 'axios';

const instance = axios.create({
	timeout: 10000,
});

export default class GoogleTranslateService {

	static async translate(query) {
		const queries = (Array.isArray(query) ? query : [query]).map((item) => (typeof item === 'string' ? item : ''));
		try {
			const params = new URLSearchParams();
			params.set('source', 'da');
			params.set('target', 'en');
			params.set('format', 'text');
			params.set('key', 'AIzaSyDNQcoZK4aCGfpcQ_k_69c9Rosftoox2RA');
			queries.forEach((item) => params.append('q', item));
			const result = await instance.get('https://translation.googleapis.com/language/translate/v2', { params });
			return result;
		}
		catch (err) {
			return null;
		}
	}	
}